<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row mb-2">
          <div class="col-sm-12">
            <h5 class="card-title">Heutiger Trainerschlüssel (Prognose)</h5>
            <div v-if="loading" class="text-muted">Laden...</div>
            <div v-else-if="rate !== null">
              <h2 :class="rateClass" class="mb-0">
                {{ formattedRate }} %
              </h2>
            </div>
            <div v-else>
              <span class="text-muted">Keine Prognose verfügbar</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { db } from "../../../../firebaseDb";
import moment from "moment-timezone";
import store from "../../../../store";

export default {
  data() {
    return {
      loading: true,
      rate: null,
      location: store.getters.userlocation,
    };
  },
  computed: {
    formattedRate() {
      if (this.rate === null) return "";
      return this.rate
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    },
    rateClass() {
      if (this.rate === null) return "";
      if (this.rate <= 30) return "text-success";
      if (this.rate <= 50) return "text-warning";
      return "text-danger";
    },
  },
  created() {
    this.loadForecast();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadForecast();
      }
    );
  },
  methods: {
    loadForecast() {
      this.loading = true;
      const today = moment().tz("Europe/Berlin").format("YYYYMMDD");
      const docId = today + "-" + this.location;
      db.collection("forecastCache")
        .doc(docId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            this.rate = doc.data().rate || 0;
          } else {
            this.rate = null;
          }
          this.loading = false;
        });
    },
  },
};
</script>
